export const menuData = [
  {icon: 'fas fa-home', class: 'home', dato: 'Inicio', src: '#home'},
  {icon: 'fas fa-address-card', class: 'nosotros', dato: 'Sobre nosotros', src: '#nosotros'},
  {icon: 'far fa-address-book', class: 'contacto', dato: 'Contacto', src: '#contacto'},
  {icon: 'far fa-images', class: 'galeria', dato: 'Galeria', src: '#galeria'},
];
